import { Address, WorkType } from 'constants/index';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { SvgUse } from '@dnse/ui';

import { UploadYourCV } from './UploadYourCV';


interface Props {
  handleClearFilter: () => void;
  departments: string[];
}

export const JobsFilter: React.FC<Props> = ({
  handleClearFilter,
  departments
}) => {
  const router = useRouter();
  const [addressFilter, setAddressFilter] = useState([]);
  const [workTypeFilter, setWorkTypeFilter] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState([]);
  const [toggleDepartmentFilter, setToggleDepartmentFilter] = useState(false);
  const isDisableClearFilterButton = router.pathname === router.asPath;

  useEffect(() => {
    setAddressFilter(
      router.query.address
        ? decodeURIComponent(router.query.address.toString()).split(',')
        : []
    );
    setDepartmentFilter(
      router.query.department
        ? decodeURIComponent(router.query.department.toString()).split(',')
        : []
    );
    setWorkTypeFilter(
      router.query.workType
        ? decodeURIComponent(router.query.workType.toString()).split(',')
        : []
    );
  }, [router.query]);

  const handleUpdateAddressFilter = (address: string) => {
    const index = addressFilter.indexOf(address);
    const addressFilterClone = [...addressFilter];
    if (index === -1) {
      addressFilterClone.push(address);
    } else {
      addressFilterClone.splice(index, 1);
    }
    setAddressFilter(addressFilterClone);
    if (addressFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          address: encodeURIComponent(addressFilterClone.join(','))
        }
      });
    } else {
      const { address, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  const handleUpdateDepartmentFilter = (department: string) => {
    const index = departmentFilter.indexOf(department);
    const departmentFilterClone = [...departmentFilter];
    if (index === -1) {
      departmentFilterClone.push(department);
    } else {
      departmentFilterClone.splice(index, 1);
    }
    setDepartmentFilter(departmentFilterClone);
    if (departmentFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          department: encodeURIComponent(departmentFilterClone.join(','))
        }
      });
    } else {
      const { department, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  const handleUpdateWorkTypeFilter = (workType: string) => {
    const index = workTypeFilter.indexOf(workType);
    const workTypeFilterClone = [...workTypeFilter];
    if (index === -1) {
      workTypeFilterClone.push(workType);
    } else {
      workTypeFilterClone.splice(index, 1);
    }
    setWorkTypeFilter(workTypeFilterClone);
    if (workTypeFilterClone.length > 0) {
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: {
          ...router.query,
          workType: encodeURIComponent(workTypeFilterClone.join(','))
        }
      });
    } else {
      const { workType, ...rest } = router.query;
      router.push({
        pathname: '/co-hoi-viec-lam',
        query: rest
      });
    }
  };

  return (
    <div className="flex flex-col w-[265px] gap-y-4">
      <div className="flex justify-between text-sm font-medium">
        <span className="">Bộ lọc</span>
        <button
          data-testid="clear-filter-button"
          className={`underline text-brand-300 ${
            isDisableClearFilterButton ? 'opacity-50' : ''
          }`}
          onClick={handleClearFilter}
          disabled={isDisableClearFilterButton}
        >
          Xoá bộ lọc
        </button>
      </div>
      <div
        className="w-full px-3 py-4 rounded"
        style={{
          border: '1px solid  var(--light-line, rgba(0, 0, 0, 0.05))'
        }}
      >
        <div className="flex items-center gap-x-1 text-sm font-medium mb-[9px]">
          <SvgUse
            id="location-outline"
            width={16}
            height={16}
            className="text-gray-800"
          />{' '}
          Địa điểm
        </div>
        <div className="flex flex-wrap gap-2">
          {Address.map((address, index) => (
            <button
              data-testid="address-filter-button"
              key={index}
              style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)' }}
              className={`cursor-pointer rounded-[100px] px-4 py-2 text-gray-800 text-sm font-normal ${
                addressFilter.includes(address) ? 'bg-brand-300 text-white' : ''
              }`}
              onClick={() => handleUpdateAddressFilter(address)}
            >
              {address}
            </button>
          ))}
        </div>
      </div>
      <div
        className="w-full px-3 py-4 rounded"
        style={{
          border: '1px solid  var(--light-line, rgba(0, 0, 0, 0.05))'
        }}
      >
        <div className="flex items-center gap-x-1 text-sm font-medium mb-[9px]">
          <SvgUse
            id="outline-clock"
            width={16}
            height={16}
            className="text-gray-800"
          />{' '}
          Hình thức làm việc
        </div>
        <div className="flex flex-wrap gap-2">
          {WorkType.map((worktype, index) => (
            <button
              key={index}
              style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)' }}
              className={`cursor-pointer rounded-[100px] px-4 py-2 text-gray-800 text-sm font-normal ${
                workTypeFilter.includes(worktype)
                  ? 'bg-brand-300 text-white'
                  : ''
              }`}
              onClick={() => handleUpdateWorkTypeFilter(worktype)}
            >
              {worktype}
            </button>
          ))}
        </div>
      </div>
      <div
        className="w-full px-3 py-4 rounded"
        style={{
          border: '1px solid  var(--light-line, rgba(0, 0, 0, 0.05))'
        }}
      >
        <div className="flex items-center justify-between gap-x-1 text-sm font-medium mb-[9px]">
          <div className="flex gap-x-1">
            <SvgUse
              id="department-outline"
              width={16}
              height={16}
              className="text-gray-800"
            />Phòng ban
          </div>
          <SvgUse
            id={toggleDepartmentFilter ? "chevron-up-red" : "chevron-down-gray"} width={16} height={16}
            className="text-gray-800 cursor-pointer"
            onClick={() => setToggleDepartmentFilter(!toggleDepartmentFilter)}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {departments
            .slice(0, toggleDepartmentFilter ? departments.length : 3)
            .map((department, index) => (
              <button
                key={index}
                style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)' }}
                className={`cursor-pointer rounded-[100px] px-4 py-2 text-gray-800 text-sm font-normal ${
                  departmentFilter.includes(department)
                    ? 'bg-brand-300 text-white'
                    : ''
                }`}
                onClick={() => handleUpdateDepartmentFilter(department)}
              >
                {department}
              </button>
          ))}
        </div>
      </div>
      <UploadYourCV />
    </div>
  );
};
